import React, { useState, useEffect } from "react";
import { Skeleton, Box, LinearProgress, Alert, Fade, AlertTitle } from "@mui/material";

const SkeletonWrapper = ({ 
  isLoading = false,
  isError = false,
  errorMessage = "Unable to load content.",
  children = null,
  disabled = false,
}) => {

  const [isInitialLoad, setInitialLoad] = useState(!disabled)

  useEffect(() => {
    let timer;

    if((!isLoading && !isError && isInitialLoad)){
      timer = setTimeout(() => {
        setInitialLoad(false);
      }, 300);
    }

    return () => clearTimeout(timer);
  }, [isLoading, isError, isInitialLoad]);

  return (
    <>
        {(isInitialLoad) && (
          <Box sx={{ position: "relative", borderRadius: '10px', overflow: 'hidden'}}>
          <Skeleton
            variant="rectangular"
            animation={!isError ? "pulse" : false}
            style={{minWidth: '100%'}}
            sx={{ bgcolor: 'grey.300',  }}
          >
            {children}
          </Skeleton>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
              }}
            >
              {!isError ?
                  <LinearProgress color="primary" sx={{height: "2px"}}/>
                :
                <>
                  <Alert variant="filled" severity="error">
                    <AlertTitle>Error</AlertTitle>
                    {errorMessage}
                  </Alert>
                </>
              }
            </Box>
          </Box>
        )}
        {(!isInitialLoad) &&
        <Fade in={true} timeout={!disabled ? 500 : 0}>
          <Box sx={{ position: "relative"}}>
            {children}
            {(isLoading) && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                }}
              >
                <LinearProgress color="primary" sx={{height: "2px"}}/>
              </Box>
            )}
          </Box>
        </Fade>
        }
    </>
  );
};

export default SkeletonWrapper;
